import React from 'react';
import {
    DropdownV2,
    Icon,
    PriorityIcon,
    Flex,
    Text,
    useDropdown,
    noop
} from '@priority-software/priority-style-react';
import texts from '../../texts';
import styles from './styles.module.scss';
import classNames from 'classnames';
import {ignoreDragClass} from '../../modules/HomepageGroups/parts/Item/utils';

type Props = {
    removePortlet: () => void;
    openInWindow: () => void;
    openChooseDates: () => void;
    showDateRange?: boolean;
};

export const PortletSettingsDropdown = (props: Props) => {
    const {removePortlet, openInWindow, openChooseDates, showDateRange} = props;
    const {isOpen, closeDropdown, toggleOpen} = useDropdown({onClose: noop});

    const onDelete = () => {
        removePortlet();
        closeDropdown();
    };

    return (
        <DropdownV2
            isOpen={isOpen}
            width={'contentWidth'}
            onClose={closeDropdown}
            openingSide={'leftSide'}
            componentClasses={classNames(styles.component, ignoreDragClass)}
            trigger={
                <Icon
                    icon={PriorityIcon.threeDots}
                    componentClasses={classNames(styles.headerIcon, ignoreDragClass)}
                    iconColor="secondary-500"
                    onClick={toggleOpen}
                />
            }
        >
            <Flex componentClasses={styles.settingsContainer} direction="column">
                <div className={styles.menuItemWrapper}>
                    <Text
                        skin="label-2"
                        textColor="primary-700"
                        componentClasses={styles.headerMenuItem}
                        onClick={onDelete}
                    >
                        {texts.remove_label}
                    </Text>
                </div>
                <div className={styles.separator} />
                <div className={styles.menuItemWrapper}>
                    <Text
                        skin="label-2"
                        textColor="primary-700"
                        componentClasses={styles.headerMenuItem}
                        onClick={openInWindow}
                    >
                        {texts.portlet_open_in_window}
                    </Text>
                </div>
                {showDateRange ? (
                    <>
                        <div className={styles.separator} />
                        <div className={styles.menuItemWrapper}>
                            <Text
                                skin="label-2"
                                textColor="primary-700"
                                componentClasses={styles.headerMenuItem}
                                onClick={openChooseDates}
                            >
                                {texts.portlet_choose_dates}
                            </Text>
                        </div>
                    </>
                ) : null}
            </Flex>
        </DropdownV2>
    );
};
